"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var queryParams = {
    getParam: function (queryParamName, location) {
        var search = location.search;
        var params = new URLSearchParams(search);
        return params.get(queryParamName);
    },
    changeParamValue: function (location, history, paramName, oldValue, newValue) {
        var oldSearchParams = location.search;
        var newSearchParams = oldSearchParams.replace(paramName + "=" + oldValue, paramName + "=" + newValue);
        history.replace(__assign(__assign({}, location), { search: newSearchParams }));
    },
    addParamValue: function (location, history, paramName, newValue) {
        var oldSearchParams = location.search;
        var newSearchParams = oldSearchParams + "&" + paramName + "=" + newValue;
        history.replace(__assign(__assign({}, location), { search: newSearchParams }));
    },
};
exports.default = queryParams;
